// eslint-disable-next-line no-shadow
export enum BusinessType {
  BureauOfIndianAffairsAndIndianTribeTreaties = 'Bureau Of Indian Affairs And Indian Tribe Treaties',
  Corporation = 'Corporation',
  Estates = 'Estates',
  IndividualOperatingAsABusiness = 'Individual Operating As A Business',
  JointOperations = 'Joint Operations/ventures And Co-ownerships',
  LandlordTenant = 'Landlord/Tenant',
  LimitedLiabilityCompany = 'Limited Liability Company',
  NonProfitOrganizations = 'Non-Profit Or Tax-Exempt Organizations',
  Partnership = 'Partnership',
  PublicSchools = 'Public Schools',
  ReceiverOrLiquidator = 'Receiver or Liquidator',
  StateLocalGovernment = 'State/Local Government',
  TrustIrrevocable = 'Trust - Irrevocable',
  TrustRevocable = 'Trust - Revocable',
}

export const businessTypes = Object.values(BusinessType)
